import Axios from "axios";
import { SERVER_URL } from "../config";
import { authHeader, handleError } from "../helpers";

let baseRoute = SERVER_URL;

export const appServices = {
    appConfig
};

function appConfig(domain) {
    console.log("into appServices(appConfig)");
    return Axios
        .get(`${baseRoute}/splash/${encodeURIComponent(domain)}`, {
            // Do not keep the whole application on the splash screen forever
            // when the configuration endpoint is unavailable.
            timeout: 10000
        })
        .then((res) => {
            console.log("res.user >> ");
            console.log(res.data.data);
            return res.data;
        })
        .catch(function (error) {
            if (error.response) {
                console.log(error.response.data);
                console.log(error.response.status);
            }
        });
}
